export default "__VITE_ASSET__UnOI5OKF__"